exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress-container[data-v-50527234] {\n    width: 100%;\n}\n.progress[data-v-50527234] {\n    height: 10px;\n    background-color: #e0e0e0;\n}\n\n\n", ""]);

// exports
